// extracted by mini-css-extract-plugin
export default {"root":"vGFjMGMXpN","line":"gSguksjpdi"};